import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTodayEngagementBookings } from '../../salon-admin/utils/checkinQueueApi';
import EngagementExpectedToday from '../../admin-shared/EngagementExpectedToday';
import { SALON_STYLIST_CHECKIN_PATH, SALON_STYLIST_GUEST_PATH } from '../config/salonApp';
import { handoffFromCheckin } from '../utils/visitHandoff';
import { setActiveCheckinSession } from '../utils/salonFaceSession';
import './ExpectedTodayBookings.css';

function goToStylistGuest(navigate, checkin, booking) {
  const faceUserId = checkin.face_user_id || checkin.faceUserId;
  setActiveCheckinSession({
    id: checkin.id,
    code: checkin.customer_code,
    status: checkin.status,
    faceUserId,
  });
  handoffFromCheckin(checkin, {
    faceUserId,
    customerName: booking?.customer_name || checkin.customer_name,
    mobile: booking?.customer_phone || checkin.mobile,
  });
  navigate(SALON_STYLIST_GUEST_PATH, {
    state: { checkinId: checkin.id, stylistLed: true, fromBooking: true },
  });
  window.dispatchEvent(new Event('checkin-queue-updated'));
}

/**
 * @param {{ compact?: boolean, className?: string, pollMs?: number }} props
 */
export default function ExpectedTodayBookings({ compact = false, className = '', pollMs = 12000 }) {
  const navigate = useNavigate();
  const fetchBookings = useCallback(() => fetchTodayEngagementBookings(), []);

  const onCheckIn = useCallback(
    (booking) => {
      navigate(SALON_STYLIST_CHECKIN_PATH, {
        state: { engagementBooking: booking },
      });
    },
    [navigate],
  );

  const onOpenVisit = useCallback(
    (booking, meta) => {
      goToStylistGuest(
        navigate,
        {
          id: meta.id,
          customer_name: booking?.customer_name || meta.customer_name,
          mobile: booking?.customer_phone || meta.mobile,
        },
        booking,
      );
    },
    [navigate],
  );

  return (
    <EngagementExpectedToday
      compact={compact}
      className={className}
      pollMs={pollMs}
      fetchBookings={fetchBookings}
      onCheckIn={onCheckIn}
      onOpenVisit={onOpenVisit}
    />
  );
}
